'use es6';

import notificationsMiddleware from './notificationsMiddleware';
export default [notificationsMiddleware];